export default __webpack_public_path__ + "static/media/learning_4.2bcac9f7.svg";